import React from 'react';
import styles from './Input.module.scss';
import classnames from 'classnames';

/**
 * @type {React.FC<any>}
 * @deprecated
 */
const Input = React.memo(function Input({
  error = null,
  touched,
  wrapperClass = null,
  inputStyle = 'user',
  className = {},
  small = false,
  ...props
}) {
  return (
    <div className={classnames(styles.root, small ? styles.smallWrapper : null, wrapperClass)}>
      <input
        className={classnames(
          small ? styles.smallInput : styles.input,
          styles[inputStyle],
          className,
        )}
        {...props}
      />
      <span className={styles.error}>{error}</span>
    </div>
  );
});

export { Input };
